var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"sp-privacy-policy-text":"direct-text","sp-lang-code":"en"}})
}
var staticRenderFns = []

export { render, staticRenderFns }